import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("mask", {
  id: "a",
  width: "16",
  height: "16",
  x: "0",
  y: "0",
  maskUnits: "userSpaceOnUse",
  style: {"mask-type":"alpha"}
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#D9D9D9",
    d: "M0 0h16v16H0z"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("g", { mask: "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#A09FA6",
    d: "M13.028 13.718 8.841 9.531q-.5.412-1.15.646a4 4 0 0 1-1.345.234q-1.71 0-2.893-1.184Q2.27 8.043 2.27 6.335q0-1.71 1.184-2.894t2.892-1.184q1.71 0 2.893 1.184 1.185 1.183 1.185 2.893 0 .714-.24 1.364t-.64 1.13l4.188 4.188zM6.346 9.411q1.29 0 2.183-.895.894-.894.894-2.182 0-1.29-.894-2.183-.894-.894-2.183-.894t-2.183.894-.894 2.183.894 2.182 2.183.895"
  })
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }